var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVuesaxlinearsecurityUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policies",
    transform: "translate(-666.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "security-user",
    transform: "translate(666.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.831055, 2.829875)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96082815,2.97853486 C1.33166151,3.58770153 0,5.5143526 0,7.25685263 L0,17.7826756 C0,19.4543422 1.10501558,21.6501791 2.4508489,22.6560124 L8.54249827,27.2035435 C10.5399982,28.7052101 13.8266425,28.7052101 15.8241425,27.2035435 L21.9158351,22.6560124 C23.2616684,21.6501791 24.3666407,19.4543422 24.3666407,17.7826756 L24.3666407,7.25685263 C24.3666407,5.5143526 23.0349792,3.58770153 21.4058126,2.97853486 L14.3366597,0.329375003 C13.132493,-0.109791668 11.2058143,-0.109791668 10.029981,0.329375003 L2.96082815,2.97853486 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.160889, 10.483195)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65450541,4.98669434 C2.32283875,4.94419434 1.26033529,3.83918048 1.26033529,2.49334717 C1.26033529,1.11918046 2.37951575,0 3.75368245,0 C5.12784916,0 6.24702962,1.11918046 6.24702962,2.49334717 C6.23286296,3.85334714 5.17034566,4.94419434 3.838679,4.98669434 C3.78201233,4.98669434 3.71117208,4.98669434 3.65450541,4.98669434 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01999996,12.2540925 C2.56416667,13.2882592 5.10000138,13.2882592 6.6441681,12.2540925 C8.00416807,11.3474258 8.00416807,9.85994466 6.6441681,8.95327802 C5.11416804,7.91911132 2.57833332,7.91911132 1.01999996,8.95327802 C-0.340000014,9.85994466 -0.340000014,11.3474258 1.01999996,12.2540925 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxlinearsecurityUser);
export default __webpack_public_path__ + "static/media/vuesaxlinearsecurity-user.2927d329778566cd15d4c6d977f22824.svg";
export { ForwardRef as ReactComponent };